import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import ContentAsync from './lazy';

import './style.scss';

const HandleAddressesModalLoader = ({ isOpen, close }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (isOpen && !loaded) {
      setLoaded(true);
    }
  }, [isOpen, loaded]);

  return loaded ? (
    <ContentAsync
      isOpen={isOpen}
      close={close}
    />
  ) : null;
};

export default HandleAddressesModalLoader;

HandleAddressesModalLoader.propTypes = {
  isOpen: PropTypes.instanceOf(Object),
  close: PropTypes.func,
};

HandleAddressesModalLoader.defaultProps = {
  isOpen: null,
  close: null,
};
